import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'

Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {
        distritos: [],
        horarios: [],
        direDistri: '',

        turnosActivos: {},
        tmpTurno: {},
        //hay nuevo turno
        nuevoTurno: null,

        //Dias no laborables
        diasNoLaborables: [],
        ultimaFechaCargada: ''
    },
    getters: {
        distritos(state) {
            return state.distritos
        },
        horarios(state) {
            return state.horarios
        },
        direDistri(state) {
            return state.direDistri
        },
        turnosActivos(state) {
            return state.turnosActivos
        },
        tmpTurno(state) {
            return state.tmpTurno
        },
        nuevoTurno(state) {
            return state.nuevoTurno
        },
        diasNoLaborables(state) {
            return state.diasNoLaborables
        },
        ultimaFechaCargada(state) {
            return state.ultimaFechaCargada
        }
    },
    mutations: {
        setDistritos(state, payload) {
            state.distritos = payload
        },
        setHorarios(state, payload) {
            state.horarios = payload
        },
        setTurnosActivos(state, payload) {
            (payload !== undefined) ? state.nuevoTurno = true : state.nuevoTurno = false
            if (!state.nuevoTurno) {
                state.turnosActivos = {}
            }
            else {
                state.turnosActivos = payload
            }
            //seteo nuevoTurno que indica si existe turno
        },
        setDireDistritos(state, payload) {
            state.direDistri = payload
        },
        setTmpTurno(state, payload) {
            (payload) ? state.tmpTurno = payload : state.tmpTurno = {}
        },
        setNuevoTurno(state, payload) {
            state.nuevoTurno = payload
        },
        setDiasNoLaborables(state, payload) {
            state.diasNoLaborables = payload
            state.ultimaFechaCargada = payload[payload.length - 1].desde
        }
    },
    actions: {
        /*  Envio:
                fecha: "dd-mm-aaaa"
                fecha2: "aaaa-mm-dd"
                nroafi: "1"
                  
            Respuesta (ejemplo):
                {[
                    coddis: "I"
                    desdistrito: "Bahia Blanca"
                    direccion: "Americo Vespucio nro. 250"
                    id: 1
                ]}          
        */
        async getDistritos({ commit, dispatch }, obj) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/turnos/obtenerDistritos',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then((response) => {
                    const res = response.data['distritos']
                    commit('setDistritos', res)
                })
                .catch((error) => {
                    console.log("asda")
                    console.log(error)
                })
        },


        /*  Envio:
                nroafi: 1
                fecha: aaaa/mm/dd
                fecha2: "aaaa-mm-dd"
                idDistrito: 1
                dia: 3
                  
            Respuesta (ejemplo):
                {
                    "success": 1,
                    "horarios": [
                        {
                            distrito: 1
                            dia: 7
                            hora: 8
                            minuto: 15
                            ocupado: 0
                        }
                    ]
                }          
        */
        async getHorarios({ commit, dispatch }, obj) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/turnos/obtenerHorarios',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then((response) => {
                    const success = response.data.success
                    if (success) {
                        const res = response.data.horarios
                        commit('setHorarios', res)
                    } else {
                        commit('setHorarios', [])
                    }
                })
                .catch((error) => {
                    commit('setHorarios', [])

                })
        },
        async getDireDistri({ commit }, obj) {
            /*  Envio:
                    nroafi: 1
                    idDistrito: 1
                      
                Respuesta (ejemplo):
                    {
                        success: 1
                        direccionDistrito: "Americo Vespucio nro. 250"
                    }          
            */
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/turnos/obtenerDireccionDistrito',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then((response) => {
                    const res = response.data.message
                    //commit('setDireDistritos', res)
                })
                .catch((error) => {
                }).finally(() => {
                })
        },
        async getTurnosActivos({ commit, dispatch }, data) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/turnos/obtenerTurnosActivos',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(data)
            })
                .then((response) => {
                    const res = response.data.turnosActivos
                    commit('setTurnosActivos', res[0])
                }).finally(() => {
                    dispatch('auth/setSktLoader', false, { root: true })
                })
        },
        async getDiasNoLaborables({ commit, dispatch }, data) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/turnos/obtenerDiasNoLaborables',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(data)
            })
                .then((response) => {
                    const res = response.data.diasNoLaborables
                    commit('setDiasNoLaborables', res)
                })
                .catch((error) => {
                })
        },

        guardarTurnoTmp({ commit, dispatch }, tmpTurno) {
            commit('setTmpTurno', tmpTurno)
        },

        async solicitarTurno({ commit, dispatch, state }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/turnos/solicitarTurno',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: state.tmpTurno
            })
                .then((response) => {
                    const res = response.data
                    dispatch('notificaciones/startLoading', null, { root: true })
                    commit('setNuevoTurno', res.success)
                    dispatch('notificaciones/showSnack', {
                        message: res.msg,
                        type: '200'
                    }, { root: true })
                })
                .catch((error) => {
                    dispatch('notificaciones/showSnack', {
                        message: "Error al intentar solicitar su turno.",
                        type: '400'
                    }, { root: true })
                }).finally(() => {
                    dispatch('notificaciones/stopLoading', null, { root: true })
                });
        },
        async cancelarTurno({ commit, dispatch }, data) {
            dispatch('notificaciones/startLoading', null, { root: true })
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/turnos/cancelarTurno',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(data)
            })
                .then((response) => {
                    const res = response.data
                    dispatch('notificaciones/showSnack', {
                        message: "Turno cancelado con éxito.",
                        type: '200'
                    }, { root: true })
                })
                .catch((error) => {
                    dispatch('notificaciones/showSnack', {
                        message: "Error, turno no cancelado. Intente nuevamente.",
                        type: '400'
                    }, { root: true })
                }).finally(() => {
                    dispatch('notificaciones/stopLoading', null, { root: true })
                });
        },
    }

});